<template>
  <div id="container-table" class="overflow-auto">
    <ts-table :columnLengths="7" :records="datatable">
      <template v-slot:thead>
        <thead>
          <tr>
            <th>{{ $t('approvalWorkFlow.levelOrder') }}</th>
            <th>{{ $t('approvalWorkFlow.approverType') }}</th>
            <th>{{ $t('approvalWorkFlow.approver') }}</th>
            <th>{{ $t('approvalWorkFlow.activity') }}</th>
            <th>{{ $t('approvalWorkFlow.approverTypeCc') }}</th>
            <th>{{ $t('approvalWorkFlow.approverCc') }}</th>
            <th style="width: 1px;">
              <div class="d-flex">
                <button
                  type="button"
                  class="btn btn-primary btn-xs"
                  v-tooltip="$t('add_new')"
                  @click.prevent="addNew(index)"
                >
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </th>
          </tr>
          <TableProgressBar v-show="loading" :columnLength="7" />
        </thead>
      </template>
      <template v-slot="{ record }">
        <td width="15%">
          <input
            type="number"
            class="form-control"
            v-model="record.level_order"
          />
        </td>
        <td>
          <select
            class="form-control"
            v-model="record.approver_type_id"
            @change="onApproverTypeChange(record)"
          >
            <option :value="null" disabled selected style="display: none;">{{
              $t('select')
            }}</option>
            <option
              v-for="(appType, index) in approverTypes"
              :key="index"
              :value="appType.approver_type_id"
              >{{ appType.approver_type }}</option
            >
          </select>
        </td>
        <td width="15%">
          <select
            v-if="record.approver_type_id == null"
            class="form-control"
            v-model="record.approver_type_value"
            :disabled="record.is_auto_generate_value"
          >
            <option :value="null" disabled selected style="display: none;">{{
              $t('select')
            }}</option>
          </select>
          <treeselect
            v-if="record.approver_type_id == 1"
            :load-options="loadEmployeeOptions"
            :options="employeeOptions"
            :placeholder="$t('approvalWorkFlow.selectEmployee')"
            :disabled="record.is_auto_generate_value"
            v-model="record.approver_type_value"
          />
          <treeselect
            v-if="record.approver_type_id == 2"
            :load-options="loadPositionOptions"
            :options="positionOptions"
            :placeholder="$t('approvalWorkFlow.selectPosition')"
            :disabled="record.is_auto_generate_value"
            v-model="record.approver_type_value"
          />
        </td>
        <td width="15%">
          <select class="form-control" v-model="record.app_activity_id">
            <option :value="null" disabled selected style="display: none;">{{
              $t('select')
            }}</option>
            <option
              v-for="(appAc, index) in approvalActivities"
              :key="index"
              :value="appAc.app_activity_id"
              >{{ appAc.app_activity }}</option
            >
          </select>
        </td>
        <td width="15%">
          <select class="form-control" v-model="record.approver_type_cc_id">
            <option :value="null" disabled selected style="display: none;">{{
              $t('select')
            }}</option>
            <option
              v-for="(appType, index) in approverTypes"
              :key="index"
              :value="appType.approver_type_id"
              >{{ appType.approver_type }}</option
            >
          </select>
        </td>
        <td width="30%">
          <select
            v-if="record.approver_type_cc_id == null"
            class="form-control"
            v-model="record.approver_type_value"
          >
            <option :value="null" disabled selected style="display: none;">{{
              $t('select')
            }}</option>
          </select>
          <treeselect
            v-if="record.approver_type_cc_id == 1"
            :load-options="loadEmployeeOptions"
            :options="employeeOptions"
            :placeholder="$t('approvalWorkFlow.selectEmployee')"
            :multiple="true"
            :limit="1"
            v-model="record.approver_type_cc_value"
          />
          <treeselect
            v-if="record.approver_type_cc_id == 2"
            :load-options="loadPositionOptions"
            :options="positionOptions"
            :placeholder="$t('approvalWorkFlow.selectPosition')"
            :multiple="true"
            :limit="1"
            v-model="record.approver_type_cc_value"
          />
        </td>
        <td width="1px">
          <div class="ts-flex">
            <button
              type="button"
              v-tooltip="$t('delete')"
              class="btn btn-danger btn-xs"
              @click="destroy(record)"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </td>
      </template>
    </ts-table>
  </div>
</template>

<script>
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import { mapState, mapActions } from 'vuex'
import TableProgressBar from '@/components/common/TsTable/TableProgressBar'

export default {
  name: 'approval-flow-detail',
  components: { TableProgressBar },
  props: ['value', 'index'],
  data() {
    return {
      datatable: [],
      item: {
        id: 0,
        level_order: '',
        approver_type_id: null,
        is_auto_generate_value: false,
        approver_type_value: null,
        app_activity_id: null,
        approver_type_cc_id: null,
        approver_type_cc_value: []
      },
      employeeOptions: null,
      positionOptions: null,
      loading: false
    }
  },
  created() {},

  computed: {
    ...mapState('approvalWorkFlow', [
      'approverTypes',
      'approvalActivities',
      'employees',
      'positions'
    ])
  },

  methods: {
    ...mapActions('approvalWorkFlow', ['fetchPositions', 'fetchEmployees']),

    onApproverTypeChange(item) {
      try {
        let approverType = this.approverTypes.find(
          a => a.approver_type_id == item.approver_type_id
        )
        item.approver_type_value = null
        item.is_auto_generate_value = approverType.is_auto_generate_value
      } catch (e) {
        item.is_auto_generate_value = false
      }
    },

    destroy(item) {
      this.datatable.splice(this.datatable.indexOf(item), 1)
    },

    addNew(index) {
      this.datatable.push(_.clone(this.item))
    },
    pushToDatatable() {
      this.value.forEach(data => {
        let detail = Object.assign({}, this.newItem, data, {
          id: data.id,
          level_order: data.level_order,
          approver_type_id: data.approver_type_id,
          is_auto_generate_value: data.is_auto_generate_value,
          approver_type_value:
            data.approver_type_value != 0 ? data.approver_type_value : null,
          app_activity_id: data.app_activity_id,
          approver_type_cc_id: data.approver_type_cc_id,
          approver_type_cc_value: this.getReceiverList(
            data.approver_type_cc_id,
            data.approver_type_cc_value
          )
        })
        this.$nextTick(() => {
          this.datatable.push(detail)
        })
      })
    },
    getReceiverList(approver_type_cc_id, approver_type_cc_value) {
      if (approver_type_cc_id == 1) {
        if (approver_type_cc_value.length <= 0) {
          return []
        }
        let items = approver_type_cc_value.split(',')
        return items.map(el => {
          let employee = this.employees.filter(em => em.staff_id == el)
          return employee[0].staff_id
        })
      } else {
        if (approver_type_cc_value.length <= 0) {
          return []
        }
        let items = approver_type_cc_value.split(',')
        return items.map(el => {
          let position = this.positions.filter(em => em.position_id == el)
          return position[0].position_id
        })
      }
    },
    async loadEmployeeOptions({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        this.employeeOptions = null
        this.employeeOptions = await this.employees.map(el => ({
          id: el.staff_id,
          label: el.name_en
        }))
      }
    },
    async loadPositionOptions({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        this.positionOptions = null
        this.positionOptions = await this.positions.map(el => ({
          id: el.position_id,
          label: el.pos_name_en
        }))
      }
    }
  },

  watch: {
    value: {
      handler(val) {
        if (_.isEqual(val, this.datatable)) return

        this.pushToDatatable()
      },
      deep: true,
      immediate: true
    },

    datatable: {
      handler(val) {
        if (_.isEqual(val, this.value)) return

        this.$emit('input', val)
      },
      deep: true
    }
  }
}
</script>
<style scoped>
#container-table {
  min-height: 30vh;
  max-height: 60vh;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  z-index: 99;
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
}
</style>
